const LOCALES_OBJ = {
  English: 'en',
  Norway: 'nb'
};

const PAYPAL_LOCALES_OBJ = {
  English: 'en_US',
  Norway: 'no_NO'
};

const INTEGRATIONS_CONSTANTS = {
  Trekksoft: 'TREKKSOFT',
  'Booking.com': 'BOOKING',
  Expedia: 'EXPEDIA',
  Airbnb: 'AIRBNB',
  Citybreak: 'CITYBREAK',
  TripAdvisor: 'TRIPADVISOR'
};

const INTEGRATIONS_NAMES = {
  TREKKSOFT: 'Trekksoft',
  BOOKING: 'BOOKING',
  EXPEDIA: 'Expedia',
  AIRBNB: 'Airbnb',
  CITYBREAK: 'Citybreak',
  TRIPADVISOR: 'TripAdvisor'
};

const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const USER_TYPE = {
  employee: 'EMPLOYEE',
  owner: 'OWNER'
};

export {
  LOCALES_OBJ,
  PAYPAL_LOCALES_OBJ,
  INTEGRATIONS_CONSTANTS,
  INTEGRATIONS_NAMES,
  WEEK_DAYS,
  USER_TYPE
};
